import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DocumentsSectionStyled = styled.section`
  margin: 0 auto;
`;

export const StyledListWrapper = styled.ul`
  list-style: none;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 5rem 4rem;
  max-width: 98.4rem;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  min-height: 24rem;
`;
